// extracted by mini-css-extract-plugin
module.exports = {"text":"ClampedText_text__zBBzf"};